import { theme } from '@features/lci-report/domain/theme';
import { Coords, Slide, parseTags } from '@features/powerpoint';

export const stepText = (
  stepText: string,
  description: string,
  position: Coords
): Slide => {
  return {
    texts: [
      {
        text: parseTags(stepText),
        options: {
          ...position,
          w: 6,
          h: 1.5,
          fontSize: 12,
          color: theme.colors.white,
          align: 'center',
        },
      },
      {
        text: description,
        options: {
          x: position.x,
          y: position.y + 0.5,
          w: 6,
          h: 1.75,
          fontSize: 12,
          color: theme.colors.white,
          align: 'left',
        },
      },
    ],
  };
};
